export default "__VITE_ASSET__b7ecdcd6__"